<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      notFooterPadding
      size="1200_auto"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      :no-padding="true"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>设为否定商品投放</template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          :inline="true">
        <gj-table
            ref="gjTable"
            errorColumn
            :index="false"
            name="adSetNegKeyword"
            :loading="loading"
            :adapt-height="false"
            :height="380"
            :data="form.items"
            :columns="columns">
          <template v-slot:matchType="{ index }">
            <el-form-item
                :prop="`items.${index}.matchType`"
                class="gj-table-item">
              <gj-select
                  v-model="form.items[index].matchType"
                  :options="options.matchType"
                  width="200px"
                  :clearable="false"
              ></gj-select>
            </el-form-item>
          </template>
          <template v-slot:campaign="{ row, index }">
            <el-form-item
                :prop="`items.${index}.campaignId`"
                class="gj-table-item"
                :rules="[
                  { required: true, message: '请选择广告活动', trigger: ['change'] }
                ]">
                  <gj-select
                  :clearable="false"
                  width="200px"
                  v-model="form.items[index].campaignId"
                  :options="options.campaign"
                  @change="campaignChange(row)"
              >
                <template v-slot:default="{ option }">
                  <span :class="`state state-${option.state}`"></span>
                  {{ option.campaignName }}
                </template>
              </gj-select>
            </el-form-item>
          </template>
          <template v-slot:group="{ row, index }">
            <el-form-item
                :prop="`items.${index}.groupId`"
                :rules="[
                  { required: true, message: '请选择广告组', trigger: ['change'] }
                ]"
                class="gj-table-item">
              <gj-select
                  v-model="row.groupId"
                  width="200px"
                  :options="getGroups(row.campaignId)"
                  @change="groupChange(row)"
                  :clearable="false"
              >
                <template v-slot:default="{ option }">
                  <span :class="`state state-${option.state}`"></span>
                  {{ option.groupName }}
                </template>
              </gj-select>
            </el-form-item>
          </template>
        </gj-table>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {adStore} from "modules/ad/common/store";
  import {adFields} from "modules/ad/common/fields";
  import {formRuleMixin, modalMixIn} from "@/minxins";
  import { SP } from "@/api/ad";

  export default {
    name: "set-neg-product-modal",
    mixins: [modalMixIn, formRuleMixin],
    props: {
      marketId: {
        required: true
      },
      items: {
        required: true
      },
    },
    created() {
      this.productInit()
    },
    data() {
      return {
        adStore,
        loading: null,
        campaignOption: [],
        form: {
          items: []
        },
        options: {
          campaign: [],
          group: [],
          matchType: [
            {id:0, text:'排除ASIN', color:'#34bfa3'}
          ]
        },
        columns: [
          {...adFields.picture,width:'100px'},
          {id: 'product', header:'商品',field:'keywordText'},
          {id: 'matchType', header: '商品定位', field: 'slot:matchType', minWidth: '220px', required: true},
          {id: 'campaign', header: '广告活动', field: 'slot:campaign', minWidth: '220px', required: true},
          {id: 'group', header: '广告组', field: 'slot:group', minWidth: '220px', required: true},
        ],
      }
    },
    methods: {
      // 初始化form.items数据
      productInit() {
        this.loading = true;
        Promise.all([this.selectSpCampaigns(), this.selectSpGroups()])
          .then(() => {
            this.form.items = this.items.map(e => ({
              keywordText: e.query,
              matchType: 0,
              campaignId: e.campaignId,
              campaignName:e.campaignName,
              groupId: e.groupId,
              groupName:e.groupName,
              imageUrl:e.imageUrl,
              targetingType:e.targetingType
            }))
          })
          .complete(() => this.loading = false );
      },
      // 广告活动改变
      campaignChange(row) {
        this.changeItem(row, 'group', null)
        this.changeItem(row, 'campaignName', this.options.campaign.find(e => e.id == row.campaignId)?.text)
      },
      groupChange(row) {
        this.changeItem(row, 'groupName', this.getGroups(row.campaignId).find(e => e.id == row.groupId)?.text)
      },
      // 改变item数据
      changeItem(row = {}, type, value) {
        const opt = {
          group: () => {
            row.groupId = value
          },
          campaignName: () => {
            row.campaignName = value
          },
          groupName: () => {
            row.groupName = value
          },
        }
        opt[type]()
      },
      // 获取所有的广告活动组合
      async selectSpCampaigns() {
        const params = {
          marketId: this.marketId,
          states: [0, 1],
          groupTargetingTypes: [1, 2]
        }
        const { data } = await SP.selectSpCampaigns(params)
        this.options.campaign = data.map(e => ({
          ...e,
          id: e.campaignId,
          text: e.campaignName
        }))
      },
      // 获取所有的广告组组合
      async selectSpGroups() {
        const params = {
          marketId: this.marketId,
          states: [0, 1]
        }
        const { data } = await SP.selectSpGroups(params)
        this.options.group = data.map(e => ({
          ...e,
          id: e.groupId,
          text: e.groupName
        }))
      },
      // 获取广告组
      getGroups(id) {
        return this.options.group.filter(e => e.campaignId == id)
      },
      confirm() {
        if (this.$gjFormValidate()) {
          this.confirmLoading = true;
          const params = {
            marketId: this.marketId,
            params: this.form.items.map(item => ({
              campaignId:item.campaignId,
              campaignName:item.campaignName,
              groupId:item.groupId,
              groupName:item.groupName,
              targetingType:item.targetingType,
              asin:item.keywordText
            }))
          };
          SP.negativeTargetsAdd(params)
            .then(({ msg }) => {
              this.$gjMessage.success(msg || '创建成功');
              this.$emit('created');
              this.$gjDestroy();
            })
            .complete(() => {
              this.confirmLoading = false;
            })
        }
      }
    }


  }
</script>

<style lang="scss" scoped>
  .state {
      width: 6px;
      height: 6px;
      background: #999;
      display: inline-block;
      border-radius: 50%;
      margin-right: 3px;
      cursor: pointer;
      &.state-0 {
          background-color: #1F6EEF;
      }
      &.state-1 {
          background-color: #ddd;
      }
  }
  /deep/ .vxe-table--border-line{
    border: 1px solid #d8dadd !important;
  }
</style>
